import { ChannelCommomController } from '../ChannelCommomController';
import './AppleBusinessChat.scss';
export class AppleBusinessChatController extends ChannelCommomController {
    static $inject = ['application', 'ConfigurationsService', 'AppleBusinessChatSegmentService', 'LoadingService', '$window', '$translate'];
    constructor(application, ConfigurationsService, AppleBusinessChatSegmentService, LoadingService, $window, $translate) {
        'ngInject';
        super('applebusinesschat', ConfigurationsService);
        this.application = application;
        this.ConfigurationsService = ConfigurationsService;
        this.AppleBusinessChatSegmentService = AppleBusinessChatSegmentService;
        this.LoadingService = LoadingService;
        this.$window = $window;
        this.$translate = $translate;
        this.$onInit();
    }
    async $onInit() {
        this.LoadingService.startLoading();
        this.AppleBusinessChatSegmentService.setApplication(this.application);
        this.LoadingService.stopLoading();
    }
    trackDocumentationClick(url, target) {
        this.AppleBusinessChatSegmentService.trackAppleBusinessChatRegisterLinkClicked();
        this.$window.open(url, target);
    }
    async openDocumentation() {
        const documentationLink = await this.$translate('applebusinesschat.docs.link');
        this.$window.open(documentationLink, '_blank');
    }
}
AppleBusinessChatController.$inject = ['application', 'ConfigurationsService', 'AppleBusinessChatSegmentService', 'LoadingService', '$window', '$translate'];
